// extracted by mini-css-extract-plugin
export default {"QuerySaver":"ftpzh39rEp6yUdRvPgbs"};